module.exports = __webpack_public_path__ + "static/media/Passaros.5cf47b36.jpg";